/* tslint:disable */
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

// Import Containers
import { FullLayoutComponent} from './containers';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', component: FullLayoutComponent,canActivate: [AuthGuard], data: { title: 'Home' }, children: [
    { path: 'dicas',
      loadChildren: 'app/dicas/dicas.module#DicasModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Dicas' }
    },
    {
      path: 'intervalos',
      loadChildren: 'app/intervalos/intervalos.module#IntervalosModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Intervalos' }
    },
    {
      path: 'intensao',
      loadChildren: 'app/intensao/intensao.module#IntensaoModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Intensao' }
    },
    {
      path: 'agenda',
      loadChildren: 'app/agenda/agenda.module#AgendaModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Agenda' }
    },
    {
      path: 'denuncia',
      loadChildren: 'app/denuncia/denuncia.module#DenunciaModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Denuncia' }
    },
    {
      path: 'status',
      loadChildren: 'app/status/status.module#StatusModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Status' }
    },
    {
      path: 'chatSetor',
      loadChildren: 'app/chatSetor/chatSetor.module#ChatSetorModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Chat' }
    },
    {
      path: 'setor',
      loadChildren: 'app/setor/setor.module#SetorModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Setor' }
    },
    {
      path: 'natureza',
      loadChildren: 'app/natureza/natureza.module#NaturezaModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Natureza' }
    },
    {
      path: 'ouvidoria',
      loadChildren: 'app/ouvidoria/ouvidoria.module#OuvidoriaModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Ouvidoria' }
    },
    {
      path: 'noticia',
      loadChildren: 'app/noticia/noticia.module#NoticiaModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Noticias' }
    },
    {
      path: 'contrato',
      loadChildren: 'app/contrato/contrato.module#ContratoModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Contratos' }
    },
    {
      path: 'whatscall',
      loadChildren: 'app/whatscall/whatscall.module#WhatscallModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Whatscall' }
    },
    {
      path: 'whatsresposta',
      loadChildren: 'app/whatsResposta/whatsResposta.module#WhatsRespostaModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Resposta Rápida' }
    },
    {
      path: 'agendamento',
      loadChildren: 'app/agendamento/agendamento.module#AgendamentoModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Agendamento' }
    },
    {
      path: 'plano',
      loadChildren: 'app/plano/plano.module#PlanoModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Plano' }
    },
    {
      path: 'chatbot',
      loadChildren: 'app/chatbot/chatbot.module#ChatbotModule',
      canActivate: [AuthGuard],
      canLoad: [AuthGuard],
      data: { title: 'Dialog Bot' }
    },
    {
        path: 'promocao',
        loadChildren: 'app/promocao/promocao.module#PromocaoModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Promoção' }
      },
      {
        path: 'galeria',
        loadChildren: 'app/galeria/galeria.module#GaleriaModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Galeria' }
      },
      {
        path: 'grupo',
        loadChildren: 'app/grupo/grupo.module#GrupoModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Grupos' }
      },
      {
        path: 'contato',
        loadChildren: 'app/contato/contato.module#ContatoModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Contatos' }
      },
      {
        path: 'atendimento',
        loadChildren: 'app/atendimento/atendimento.module#AtendimentoModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Atendimento' }
      },
      {
        path: 'log',
        loadChildren: 'app/log/log.module#LogModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Log' }
      },
      {
        path: 'emprego',
        loadChildren: 'app/emprego/emprego.module#EmpregoModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Empregos' }
      },
      {
        path: 'classificado',
        loadChildren: 'app/classificado/classificado.module#ClassificadoModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Classificados' }
      },
      {
        path: 'mensagem',
        loadChildren: 'app/mensagem/mensagem.module#MensagemModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Mensagens' }
      },
      {
        path: 'usuario',
        loadChildren: 'app/usuario/usuario.module#UsuarioModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Usuarios' }
      },
      {
        path: 'atendente',
        loadChildren: 'app/atendente/atendente.module#AtendenteModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Atendentes' }
      },
      {
        path: 'parametros',
        loadChildren: 'app/parametros/parametros.module#ParametrosModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Parametros' }
      },
      {
        path: 'departamento',
        loadChildren: 'app/departamento/departamento.module#DepartamentoModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Departamento' }
      },
      {
        path: 'pergunta',
        loadChildren: 'app/pergunta/pergunta.module#PerguntaModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Perguntas' }
      },
      {
        path: 'lista',
        loadChildren: 'app/lista/lista.module#ListaModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Lista' }
      },
      {
        path: 'campanha',
        loadChildren: 'app/campanha/campanha.module#CampanhaModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Campanha'}
      },
      {
        path: 'pesquisa',
        loadChildren: 'app/pesquisa/pesquisa.module#PesquisaModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Pesquisa' }
      },
      {
        path: 'cliente',
        loadChildren: 'app/cliente/cliente.module#ClienteModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Cliente' }
      },
      {
        path: 'enquete',
        loadChildren: 'app/enquete/enquete.module#EnqueteModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Enquete' }
      },
      {
        path: 'home',
        loadChildren: 'app/home/home.module#HomeModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Mensagem' }
      },
      {
        path: 'publicidade',
        loadChildren: 'app/publicidade/publicidade.module#PublicidadeModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Publicidade' }
      },
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'template',
        loadChildren: 'app/template/template.module#TemplateModule',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { title: 'Templates' }
      },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/app.routing.ts